export const bankIncomeTableFields = [
    {
        'monthCount': '1',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '2',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '3',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '4',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '5',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '6',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '7',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '8',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '9',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '10',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '11',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    },
    {
        'monthCount': '12',
        'monthState': `${new Date().getFullYear()}-0${new Date().getMonth()+1}`,
        'payment1': 0,
        'payment2': 0,
        'payment3': 0,
        'total': 0
    }
]